<!-- 选择服务商户平台 -->
<template>
  <div>
    <!-- 选择服务商户 -->
    <el-dialog
      v-if="visible"
      class="select-sbrand-dialog-container"
      :show-close="showDialogClose"
      :visible.sync="visible"
      :title="selectSbrandDialogData.title"
      :close-on-click-modal="false"
      :width="selectSbrandDialogData.width"
      :top="selectSbrandDialogData.top"
      @close="close"
    >
      <div class="select-sbrand-wrapper">
        <div
          v-for="(item, index ) in sbrandList"
          :key="index"
          class="sbrand-cell"
          @click="refreshSbrand(item.sbrand_id)"
        >
          <div class="sbrand_img">
            <el-image
              :src="item.sbrand_logo"
              fit="cover"
            ></el-image>
          </div>
          <div class="sbrand_name">{{item.sbrand_title}}</div>
        </div>
      </div>
    </el-dialog>

    <!-- 选择服务商户后弹层提示信息框 -->
    <el-dialog
      class="sbrand-welcome-dialog-container"
      :show-close="false"
      :visible.sync="sbrandWelcomeDialogData.visible"
      :close-on-click-modal="false"
      :width="sbrandWelcomeDialogData.width"
      :top="sbrandWelcomeDialogData.top"
    >
      <div class="welcome-wrapper">
        <div class="wel-title">{{ sbrandWelcomeDialogData.title }}</div>
        <div class="wel-content">{{ curSbrandData.sbrand_title }}</div>
        <div class="wel-button">
          <el-button
            type="primary"
            @click="gotoClick"
          >开始采购</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "select-sbrand",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    showDialogClose: {
      type: Boolean,
      default: false
    },
    sbrandList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      selectSbrandDialogData: {
        title: '请选择您将进入的平台',
        top: '14vh',
        width: '760px',
      },
      curSbrandData: {},  //  选中的品牌
      sbrandWelcomeDialogData: {
        visible: false,
        title: '欢迎访问',
        top: '30vh',
        width: '600px',
      },
      timeoutId: 0,
    }
  },
  methods: {
    /**
     * 关闭回调
     */
    close() {
      this.$emit("close")
    },

    /**
     * 选择刷新服务商户
     */
    refreshSbrand(sbrandId) {
      this.$user.updateLoginUserData('user_sbrand', sbrandId, {
        success: (res) => {
          this.sbrandList.forEach((item, index) => {
            if (item.sbrand_id == sbrandId) {
              this.curSbrandData = item
              this.sbrandWelcomeDialogData.visible = true
            }
          })
          this.timeoutId = setTimeout(() => {
            this.sbrandWelcomeDialogData.visible = false;
            this.$emit("refreshSbrandSuccess");
          }, 10000);
          this.$emit("refreshSbrand");
          return false;
        },
        error: (res) => {
          this.$message.error(res.mes);
          return false;
        },
      });
    },

    /**
     * 切换页面
     */
    gotoClick() {
      this.sbrandWelcomeDialogData.visible = false;           //  隐藏提示信息
      clearTimeout(this.timeoutId);
      this.$emit("refreshSbrandSuccess");
    }

  }
}
</script>

<style lang="scss" scoped>
.select-sbrand-dialog-container {
  ::v-deep(.el-dialog__title) {
    color: #80bd01;
    font-weight: bold;
    font-size: 18px;
  }

  ::v-deep(.el-dialog__body) {
    padding: 0px 20px 30px;
  }

  .select-sbrand-wrapper {
    display: flex;
    flex-direction: row;
    // justify-content: center;
    flex-wrap: wrap;
    padding-top: 0px;
    padding-bottom: 0px;
    .sbrand-cell {
      position: relative;
      display: flex;
      flex-direction: column;
      padding: 0px 60px 60px;
      margin: 20px;
      justify-content: center;
      align-items: center;
      text-align: center;
      cursor: pointer;
      background-color: #f7f7fa;
      .sbrand_img {
        width: 200px;
        height: 140px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .sbrand_name {
        padding: 10px 10px 40px;
        font-size: 24px;
        font-weight: bold;
        display: flex;
        justify-content: center;
        align-items: center;
        max-width: 180px;
        position: absolute;
        bottom: -25px;
        height: 90px;
      }
    }
  }
}

.sbrand-welcome-dialog-container {
  .welcome-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .wel-title {
      font-size: 30px;
      font-weight: bold;
    }

    .wel-content {
      font-size: 26px;
      font-weight: bold;
      color: #80bd01;
      padding: 40px 30px 50px;
    }
  }
}
</style>